import type { ArchivoDescargado } from '../types/metas.types';

/**
 * Entrega al navegador un archivo que la API mandó como blob.
 *
 * POR QUÉ ASÍ Y NO CON UN ENLACE A LA API
 * Las rutas del Excel piden `Authorization: Bearer …`, y un `<a href>` o un
 * `window.open` a la API no llevan esa cabecera: bajarían un 401. Así que el
 * archivo se pide con `fetch`, llega como blob, y se ofrece desde un URL
 * local (`blob:`) con `<a download>`, que es lo que pone el nombre.
 *
 * El URL se revoca después, no en el mismo instante: en algunos navegadores
 * revocarlo justo tras el `click()` cancela la descarga antes de empezar.
 */
export function guardarArchivo({ nombre, blob }: ArchivoDescargado): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
